import service from "./service"

const preCheckResult = async (preCheckId) => {
    return service(preCheckId)
}

export default preCheckResult
